var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewJobBoardChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33585 9.99963C3.33585 6.31773 6.32061 3.33296 10.0025 3.33296V3.33296C13.6844 3.33296 16.6692 6.31773 16.6692 9.99963V14.2421C16.6692 14.7845 16.6692 15.0557 16.6124 15.2789C16.4462 15.9328 15.9357 16.4434 15.2818 16.6096C15.0586 16.6663 14.7874 16.6663 14.2449 16.6663H10.0025C6.32061 16.6663 3.33585 13.6815 3.33585 9.99963V9.99963Z",
    stroke: "#6D7D8B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 9.16666L12.5 9.16666",
    stroke: "#6D7D8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99854 12.5002H12.4985",
    stroke: "#6D7D8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewJobBoardChat);
export default __webpack_public_path__ + "static/media/NewJobBoardChat.6821638d.svg";
export { ForwardRef as ReactComponent };